
import React from 'react';
import Avatar from '@mui/material/Avatar';

const UserAvatarImgComponent = ({ img, name = '', lg = false }) => {
  const size = lg ? 50 : 32;
  const firstLetter = name.trim().charAt(0).toUpperCase() || '?';

  return (
    <Avatar
      src={img || undefined}
      alt={name}
      sx={{
        width: size,
        height: size,
        fontSize: lg ? 20 : 14,
        bgcolor: img ? 'transparent' : '#1976d2',
        color: 'white',
      }}
    >
      {!img && firstLetter}
    </Avatar>
  );
};

export default UserAvatarImgComponent;
